"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gidoleRegular = void 0;
const Gidole_Regular_ttf_1 = __importDefault(require("./Gidole-Regular.ttf"));
const d = {
    fontFamily: 'Gidole',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    unicodeRange: 
    // eslint-disable-next-line max-len
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const src = f => `
local('Gidole'),
url(${f}) format('ttf')
`;
exports.gidoleRegular = {
    ...d,
    fontWeight: 400,
    src: src(Gidole_Regular_ttf_1.default),
};
exports.default = [exports.gidoleRegular];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZm9udHMvR2lkb2xlL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDhFQUFpRDtBQUVqRCxNQUFNLENBQUMsR0FBRztJQUNSLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLFNBQVMsRUFBRSxRQUFRO0lBQ25CLFdBQVcsRUFBRSxNQUFNO0lBQ25CLFVBQVUsRUFBRSxHQUFHO0lBQ2YsWUFBWTtJQUNWLG1DQUFtQztJQUNuQyxvSkFBb0o7Q0FDdkosQ0FBQztBQUVGLE1BQU0sR0FBRyxHQUFHLENBQUMsQ0FBQyxFQUFFLENBQUM7O01BRVgsQ0FBQztDQUNOLENBQUM7QUFFVyxRQUFBLGFBQWEsR0FBRztJQUMzQixHQUFHLENBQUM7SUFDSixVQUFVLEVBQUUsR0FBRztJQUNmLEdBQUcsRUFBRSxHQUFHLENBQUMsNEJBQWEsQ0FBQztDQUN4QixDQUFDO0FBRUYsa0JBQWUsQ0FBQyxxQkFBYSxDQUFDLENBQUMifQ==